

import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { dateFormator, mapTableRows } from "../../../../utils";
import { getAllImmigrations, getAllImmigrationsStart } from "../../../../redux/slices/immigration/immigrationSlice";
import {   Avatar,
  Backdrop,
  Button,
  DocumentsList,
  LogoLoader,
  Modal,
  NewTable,
  StatusTags, } from "../../../../components";
import { transformFiles } from "../../../../utils/transformFiles";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../hooks";
import AddVisaModal from "./Visa/AddVisaModal";
import { VisaType } from "../../../../assets/data/enumData";

const Visa = ({activeModal,setActiveModal}) => {
   const { page, limit, setPage, handleLimitChange } = usePagination(
      10,
      (newPage, newLimit) => {
        // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
      }
    );
  const dispatch = useDispatch();
   const { value } = useSelector(
      (state) => state.totalCount
    );
    const { loading,allImmigrations } = useSelector(
      (state) => state.immigration
    );
     const totalCount = value?.visa?.data || 0
    const isLoading = loading;
  console.log("allImmigrations",allImmigrations);
  const lcaTableData= allImmigrations?.visa||[]
  console.log("lcaTableData",lcaTableData);
  const [documentModal, setDocumentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
const [selectRowData,setSelectRowData]=useState(null)
const [isEditMode,setIsEditMode]=useState(false)
  
  const handleclick = () => {
    setDocumentModal(!documentModal);
  };
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
  } = useSelector((state) => state.employee);
  const { immigrations: immigrationsTableData } = useSelector(
    (state) => state.immigration
  );
  const tableData =
    Array.isArray(immigrationsTableData?.data?.visa) &&
    immigrationsTableData.data.visa.length > 0
      ? immigrationsTableData?.data?.visa
      : [];
  const handelDocumetsModal = (documents) => {
    setDocumentModal(!documentModal);
    setSelectedDocuments(documents);
  };
  const handleClickEdit=(row)=>{
setSelectRowData(row);
setActiveModal(!activeModal)
setIsEditMode(!isEditMode)
  }
  const columns = [
    {
      key: "type",
      label: "Visa Type",
      sortable: false,
        render:(row)=>{
              const findType = VisaType.find((data) => data.value === row?.type)?.label;
              return(
                <div>{findType || "Not Found"}</div>
              )
            }
    },
    {
      key: "issueDate",
      label: "Issue Date",
      render: (row) => {
        const { issueDate } = row?.approvalDetails || {};
        return dateFormator(issueDate, "month-day-year");
      },
      sortable: false,
    },
    {
      key: "expirationDate",
      label: "Expiration Date",
      render: (row) => {
        const { expiryDate } = row?.approvalDetails || {};
        return dateFormator(expiryDate, "month-day-year");
      },
      sortable: false,
    },
    {
      key: "petitionEndOn",
      label: "Petition End Date",
      render: (row) => dateFormator(row.petitionEndOn, "month-day-year"),
      sortable: false,
    },

    {
      key: "status",
      label: "Visa Status",
      render: (row) => <StatusTags tag={row.status===1?"Active":"Inactive"} />,
      sortable: false,
    },

    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        const documents = transformFiles(
          row?.approvalDetails?.attachments || []
        );
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              documents.length > 0 && "cursor-pointer"
            }`}
            onClick={
              documents.length > 0
                ? () => handelDocumetsModal(documents)
                : () => {}
            }
          >
            <span className={`${documents.length > 0 && "text-linkblue"}`}>
              {documents.length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
      sortable: false,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => <StatusTags tag={row.status} />,
      sortable: false,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit_square"
          size="xs"
          color="black"
          onClick={() => handleClickEdit(row)}
        />
      ),
      sortable: false,
    },
  ];

  const mappedRows = mapTableRows(lcaTableData, columns);
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "visas",
        coll: "Visa",
        tname: "visa",
      })
    );
    dispatch(
      getAllImmigrations({
        coll: "Visa",
        rsn: "visa",
        limit,
        page,
        ref:"Employee Document",
        incl:["uiid firstName"]
      })
    );
  }, [dispatch, page, limit]);
  const handleonClose=()=>{
  setSelectRowData(null);
  setActiveModal(!activeModal);
  setIsEditMode(!isEditMode)
  }
  console.log("selectRowData",selectRowData);
  return (
    <div className="flex flex-col overflow-hidden">
      <NewTable
        rows={mappedRows}
        columns={columns}
         serverPagination={true}
             totalCount={totalCount}
        toolbarRight={[{ hideToolbar: true }]}
         page={page}
          limit={limit}
          onPageChange={setPage}
          onLimitChange={handleLimitChange}
      />
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
       <AddVisaModal isOpen={activeModal} editData={selectRowData} onClose={handleonClose} isEditMode={isEditMode} page={page} limit={limit} />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Visa;
